
export enum NorthamptonshireRecordType  {           
        Monument = "mon",     
        Event = "event", 
        Source = "source",
        Designation = "desig",
        AreaBoundary = "bound"
}  

export enum NorthamptonshireRecordSubType  {   
    ConservationArea = "COA",
    ListedBuilding = "LB",
    LocallyListedBuilding = "LL",
    RegisteredParksAndGardens = "RG",
    RegisteredBattlefields = "RB",
    ScheduledMonument = "SAM"
}  

